
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/classroom-terms",
      function () {
        return require("private-next-pages/classroom-terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/classroom-terms"])
      });
    }
  